import { Injectable } from "@angular/core";
import { ServiceProvider } from "./service.provider";
import { DMSBaseService } from "./dms.base.service";
import { UserRegisteration } from "app/models/Auth.model";
@Injectable({
  providedIn: "root",
})
export class AuthService extends DMSBaseService {
	constructor(public provider: ServiceProvider) {
		super("", provider);
		//super('/api/auth/signin', provider);
	}

	signUp(data:UserRegisteration){
		return this.save(data,'/auth/signup')
   }
	  
  public signInUser(data) {
	return new Promise((resolve, reject) => {
		this.post(data, `/auth/signin/dms`).subscribe(
			(response) => {
				if (response.status === "SUCCESSFUL") {
					resolve(response);

					//Subscribe to check internet connection listner
					//this.subs = this.checkIsOnline$().subscribe(isOnline => {
					//  console.log(' -------- Is ONLINE -------- :: '+isOnline);
					//  this.isOnline = isOnline});
				}
				if (response.status === "ERROR") {
					reject(this.processError(response.error));
				}
			},
			(err) => {
				reject(err);
				console.log(err);
			}
		);
	});
  }

  public authenticate() {
		return new Promise((resolve, reject) => {
			this.post(null, "/auth/authenticate").subscribe(
				(response) => {
					if (response.status === "SUCCESSFUL") {
						resolve(response);
					}
					if (response.status === "ERROR") {
						reject(this.processError(response.error));
					}
				},
				(err) => {
					reject(err);
					console.log(err);
				}
			);
		});
	}

  public logout() {
		return this.signout("/auth/signout/DMS");
	}

  public resetUsername(data) {
		return new Promise((resolve, reject) => {
			this.post(data, "/auth/reset/username").subscribe(
				(response) => {
					if (response.status === "SUCCESSFUL") {
						resolve(response);
					}
					if (response.status === "ERROR") {
						reject(this.processError(response.error));
					}
				},
				(err) => {
					reject(err);
					console.log(err);
				}
			);
		});
	}

  public sendEmail(data) {
		return new Promise((resolve, reject) => {
			this.post(data, "/auth/resetPassword").subscribe(
				(response) => {
					if (response.status === "SUCCESSFUL") {
						resolve(response);
					}
					if (response.status === "ERROR") {
						reject(this.processError(response.error));
					}
				},
				(err) => {
					reject(err);
					console.log(err);
				}
			);
		});
	}

	public generate2FA(id) {
		return new Promise((resolve, reject) => {
		  this.post(null, `/auth/user/${id}/2fa/generate`).subscribe(
			(response) => {
			  if (response.status === "SUCCESSFUL") {
				resolve(response);
			  }
			  if (response.status === "ERROR") {
				reject(this.processError(response.error));
			  }
			},
			(err) => {
			  reject(err);
			  console.log(err);
			}
		  );
		});
	  }

	  public retrieve2FAStatus(data) {
		return new Promise((resolve, reject) => {
			this.post(data, '/auth/signin/2fa').subscribe(
				(response) => {
					if (response.status === "SUCCESSFUL") {
						resolve(response);
					}
					if (response.status === "ERROR") {
						reject(this.processError(response.error));
					}
				},
				(err) => {
					reject(err);
					console.log(err);
				}
			);
		});
	}

	public login2FA(data, source: string = "DMS") {
		return new Promise((resolve, reject) => {
			this.post(data,  `/auth/signin/${source}/2fa`).subscribe(
				(response) => {
					if (response.status === "SUCCESSFUL") {
						resolve(response);
					}
					if (response.status === "ERROR") {
						reject(this.processError(response.error));
					}
				},
				(err) => {
					reject(err);
					console.log(err);
				}
			);
		});
	}

	public resetPass(data) {
		return new Promise((resolve, reject) => {
		  this.put(data, "/users/resetPassword").subscribe(
			(response) => {
			  if (response.status === "SUCCESSFUL") {
				resolve(response);
				console.log(response);
			  }
			  if (response.status === "ERROR") {
				reject(this.processError(response.error));
			  }
			},
			(err) => {
			  reject(err);
			  console.log(err);
			}
		  );
		});
	  }

	verify(token) {
		return this.save(null, `/auth/signup/verify?token=${token}`);
	  }
	
	  resendEmail(userId) {
		return this.save(null, `/auth/signup/${userId}/resend`);
	  }
	  	  //getting token from server for DMS Editor/Viewer token validation
	public getToken() {
		return new Promise((resolve, reject) => {
			this.get("/auth/token").subscribe(
				(response) => {
					if (response.status === "SUCCESSFUL") {
						resolve(response);
					}
					if (response.status === "ERROR") {
						reject(this.processError(response.error));
					}
				},
				(err) => {
					reject(err);
				}
			);
		});
	}

}
